import React from 'react'
import { M_Table } from 'src/components/M_Components'

export default function Ports({ roles }) {

    return (
            <M_Table entityName={'Ports'} filtersOnTable rolePermissions={roles} />
    )
}